// src/components/CTA.js
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from 'lucide-react';

const CTA = () => {
  return (
    <>
      <style>
        {`
          .ready-sec {
            background-color: #2563eb; /* Matches bg-blue-600 from Hero.js */
            border-radius: 12px;
            padding: 20px; /* Adds space around the white container */
          }

          .ready-wrp {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 300px;
          }

          @media (min-width: 1024px) {
            .ready-wrp {
              flex-direction: row;
              justify-content: space-between;
            }
          }

          .white-container {
            background-color: white;
            border-radius: 12px;
            padding: 20px;
            width: 100%;
            box-shadow: 0 8px 12px 4px rgba(147, 197, 253, 0.3); /* Matches Hero.js shadow */
            display: flex;
            flex-direction: column;
            position: relative; /* For background image positioning */
            background-image: url('/images/home_sketch.png'); /* Background image */
            background-size: cover; /* Makes image larger and covers the container */
            background-position: center; /* Centers the image */
            background-repeat: no-repeat; /* Prevents tiling */
          }

          @media (min-width: 1024px) {
            .white-container {
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
            }
          }

          .white-container::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.4); /* Darker overlay to make background image appear darker */
            border-radius: 12px;
            z-index: 1;
          }

          .heading-block, .obj-img {
            position: relative; /* Ensures content stays above background */
            z-index: 2; /* Above the overlay */
          }

          .heading-block {
            max-width: 60%;
            padding: 0;
            margin-left: 10%; /* Shifts text and button to the right */
            color: #1e293b; /* Darker text for contrast against overlay */
            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); /* Slight shadow for readability */
          }

          .obj-img {
            display: none; /* Hide the inline image since it's now a background */
          }

          .btn.get-started {
            position: relative;
            overflow: hidden;
            background-color: #2563eb; /* Restore blue background */
            color: white; /* Restore white text */
          }

          .btn.get-started:hover {
            background-color: #1d4ed8; /* Darker blue hover, matches bg-blue-700 */
          }

          .btn.get-started:hover .btn-arrow {
            transform: translateX(5px);
          }

          .btn-arrow {
            width: 16px;
            height: 16px;
            transition: transform 0.3s ease;
          }

          .animate-fadeInUp {
            animation: fadeInUp 0.5s ease-out forwards;
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
      <section className="py-12 pt-1 ready-sec mx-4 sm:mx-6 lg:mx-8">
        <div className="max-w-4xl mx-auto container">
          <div className="ready-wrp">
            <div className="white-container">
              <div className="heading-block text-center lg:text-left mb-8 lg:mb-0">
                <h2 className="text-4xl font-bold mb-4 animate-fadeInUp">Ready to Boost Your Real Estate Data?</h2>
                <p className="text-xl mb-8 animate-fadeInUp delay-100">
                  Try our platform today<br />
                  and see how effortless data access can be.
                </p>
                <Link
                  to="/login"
                  className="btn get-started inline-flex items-center px-8 py-4 rounded-lg font-semibold hover:scale-105 transition-transform group"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#signup')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  Get Started
                  <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-2 btn-arrow" />
                </Link>
              </div>
              <div className="obj-img hidden lg:block">
                {/* Image is now in background, this div can be removed or styled differently if needed */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CTA;